
export default {

  SET_RELATIONSHIP_RULE_PAGINATED(state, relationshipRules) {
    state.relationshipRules = relationshipRules;
  }
}
